import { atom } from '@exodus/headless-ui';
import fromAmountAtom from './from-amount.js';
import toAmountAtom from './to-amount.js';
import prefillIdAtom from './prefill-id.js';
import fromAssetAtom from './from-asset.js';
import { fromAssetNameWithConfigAtom } from './from-asset-name.js';
import { toAssetNameAtom, toAssetNameWithConfigAtom } from './to-asset-name.js';
const toAssetAtom = atom((get, { selectors }) => {
    const availableAssets = get(selectors.availableAssets.all);
    const assets = Object.values(availableAssets);
    if (assets.length === 0)
        return undefined;
    const toAssetName = get(toAssetNameWithConfigAtom);
    const fromAssetName = get(fromAssetNameWithConfigAtom);
    const resolvedFromName = (availableAssets[fromAssetName] || assets[0]).name;
    const currentAsset = availableAssets[toAssetName];
    const fallbackAsset = assets[1];
    const resolved = currentAsset || fallbackAsset;
    if (resolved.name === resolvedFromName) {
        return Object.values(availableAssets).find((a) => a.name !== resolvedFromName) || resolved;
    }
    return resolved;
}, (get, set, newValue) => {
    if (!newValue)
        return set(toAssetNameAtom, undefined);
    const oldValue = get(toAssetAtom);
    const fromAsset = get(fromAssetAtom);
    set(toAssetNameAtom, newValue.name);
    set(fromAmountAtom, undefined);
    set(toAmountAtom, undefined);
    set(prefillIdAtom, null);
    if (fromAsset.name === newValue.name) {
        set(fromAssetAtom, oldValue);
    }
});
export default toAssetAtom;
